module.exports = __webpack_public_path__ + "static/img/home2.818ef918.png";